import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { RequestDecoratorModel } from "../../../../Types/requestDecoratorModel";
import { UI_CONSTANTS } from "../../../../Constants/constants";

type SourceOfChange =
  | "Attribute"
  | "Query"
  | "MeasurementsClothing"
  | "Hierarchy"
  | "Measurements"
  | "Food Volumetrics"
  | "";

export const decoratePayloadAndEndPoint = (
  editableData: any,
  selectedMenu: string
): RequestDecoratorModel => {
  //In case if any service required additional header, it need to reassign in respective block

  let sourceOfChange: SourceOfChange = "";

  switch (selectedMenu) {
    case "Query":
      sourceOfChange = "Query";
      break;
    case "Attributes":
      sourceOfChange = "Attribute";
      break;
    case "Measurements-Clothing":
      sourceOfChange = "MeasurementsClothing";
      break;
    case "Hierarchy":
      sourceOfChange = "Hierarchy";
      break;
    case "Measurements":
      sourceOfChange = "Measurements";
      break;
    case "Food Volumetrics":
      sourceOfChange = "Food Volumetrics";
      break;
    default:
      break;
  }

  return createRequestDecoratorModel(editableData, sourceOfChange);
};

function createRequestDecoratorModel(editableData: any, sourceOfChange: SourceOfChange): RequestDecoratorModel {
  const headers: RequestDecoratorModel["headers"] = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };

  switch (sourceOfChange) {
    case "Food Volumetrics":
      return {
        endPoint: endpoints.updateVolumetricsReviewData(),
        headers: headers,
        method: "POST",
        payload: createPayloadForFoodVolumetrics(editableData)
      };
      
    case "Attribute":
    case "Query":
    case "MeasurementsClothing":
    case "Hierarchy":
    case "Measurements":
      return {
        endPoint: endpoints.updateProduct(editableData?.Id),
        headers: headers,
        method: "PATCH",
        payload: createPayloadForFoodProducts(editableData, sourceOfChange)
      };

    default:
      return {
        endPoint: "",
        headers: null,
        method: "",
        payload: null
      };
  }
}

function createPayloadForFoodVolumetrics(editableData: any) {
  return {
    DCP: editableData?.dcp,
    OriginalRowNumber: editableData?.originalRowNumber,
    SuperCatDesc: editableData?.superCatDesc,
    DeptCode: editableData?.deptCode,
    CommCode: editableData?.commCode,
    PackSize: editableData?.packSize,
    SkuNo: editableData?.skuNo,
    SuppCode: editableData?.suppCode,
    SuppName: editableData?.suppName,
    OfficeDesc: editableData?.officeDesc,
    Desc: editableData?.desc,
    BreakPack: editableData?.breakPack,
    CaseLengthMm: editableData?.caseLengthMm,
    CaseWidthMm: editableData?.caseWidthMm,
    CaseHeightMm: editableData?.caseHeightMm,
    CaseWeightKg: editableData?.caseWeightKg,
    WeightUom: editableData?.weightUom,
    VolumeUom: editableData?.volumeUom,
    CasesPerLayer: editableData?.casesPerLayer,
    LayersPerPallet: editableData?.layersPerPallet,
    CasesPerPallet: editableData?.casesPerPallet,
    RejectionReason: editableData?.rejectionReason,
    FileName: editableData?.fileName,
    UploadDate: editableData?.uploadDate,
    Status: editableData?.status,
    OverridenValidations: editableData?.overridenValidations
  };
}

function createPayloadForFoodProducts(editableData: any, sourceOfChange: string) {
  return {
    FamilyGroup: editableData?.FamilyGroup,
    ProductType: editableData?.ProductType,
    Ti: editableData?.Ti,
    Hi: editableData?.Hi,
    PackSize: editableData?.PackSize,
    ProductGroup: editableData?.ProductGroup,
    BreakPack: editableData?.BreakPackIndicator,
    StillTransportable: editableData?.StillTransportable,
    EAN: editableData?.EAN,
    OuterWeight: editableData?.OuterWeight,
    OuterLength: editableData?.OuterLength,
    OuterWidth: editableData?.OuterWidth,
    OuterHeight: editableData?.OuterHeight,
    OldFamilyGroup: editableData?.OldFamilyGroup,
    Hazardous: editableData?.Hazardous,
    HazardousCode: editableData?.HazardousCode,
    Conveyable: editableData?.Conveyable,
    Flammable: editableData?.Flammable,
    ClearableFlag: editableData?.ClearableFlag,
    Lifecycle: editableData?.Lifecycle,
    NestedItem: editableData?.NestedItem,
    NestedIncrement: editableData?.NestedIncrement,
    MLOI: editableData?.MLOI,
    MLOR: editableData?.MLOR,
    Uglies: editableData?.Uglies,
    TwoPersonLift: editableData?.TwoPersonLift,
    MuType: editableData?.MuType,
    AutomationAdaptoSystem: editableData?.AutomationAdaptoSystem,
    AutomationToteFill: editableData?.AutomationToteFill,
    AutomationMinTotes: editableData?.AutomationMinTotes,
    HighRisk: editableData?.HighRisk,
    StrapTotes: editableData?.StrapTotes,
    ExpiryDateRequired: editableData?.ExpiryDateRequired,
    DimensionData: {
      Manual: editableData.Manual,
      HasWarnings: editableData.HasWarnings,
      BreakPackIndicator: editableData.BreakPackIndicator,
      OuterDimensions: createOuterDimensions(editableData),
      InnerDimensions: createInnerDimensions(editableData),
      OverridenValidations: editableData?.OverridenValidations ?? false,
    },
    Source: UI_CONSTANTS.LDMUI,
    SourceOfChange: sourceOfChange,
  };
}

function createInnerDimensions(editableData: any) {
  return {
    Height: editableData?.InnerDimensions?.Height || null,
    HeightUOM: editableData?.InnerDimensions?.Height
      ? editableData?.InnerDimensions?.HeightUOM
      : null,
    Width: editableData?.InnerDimensions?.Width || null,
    WidthUOM: editableData?.InnerDimensions?.Width
      ? editableData?.InnerDimensions?.WidthUOM
      : null,
    Length: editableData?.InnerDimensions?.Length || null,
    LengthUOM: editableData?.InnerDimensions?.Length
      ? editableData?.InnerDimensions?.LengthUOM
      : null,
    Weight: editableData?.InnerDimensions?.Weight || null,
    WeightUOM: editableData?.InnerDimensions?.Weight
      ? editableData?.InnerDimensions?.WeightUOM
      : null,
    Volume: editableData?.InnerDimensions?.Volume
      ? editableData?.InnerDimensions?.Volume
      : null,
    VolumeUOM: editableData?.InnerDimensions?.Volume
      ? editableData?.InnerDimensions?.VolumeUOM
      : null,
    Ti: editableData?.InnerDimensions?.Ti || null,
    Hi: editableData?.InnerDimensions?.Hi || null,
  };
}

function createOuterDimensions(editableData: any) {
  return {
    Height: editableData?.OuterDimensions?.Height || null,
    HeightUOM: editableData?.OuterDimensions?.Height
      ? editableData?.OuterDimensions?.HeightUOM
      : null,
    Width: editableData?.OuterDimensions?.Width || null,
    WidthUOM: editableData?.OuterDimensions?.Width
      ? editableData?.OuterDimensions?.WidthUOM
      : null,
    Length: editableData?.OuterDimensions?.Length || null,
    LengthUOM: editableData?.OuterDimensions?.Length
      ? editableData?.OuterDimensions?.LengthUOM
      : null,
    Weight: editableData?.OuterDimensions?.Weight || null,
    WeightUOM: editableData?.OuterDimensions?.Weight
      ? editableData?.OuterDimensions?.WeightUOM
      : null,
    Volume: editableData?.OuterDimensions?.Volume
      ? editableData?.OuterDimensions?.Volume
      : null,
    VolumeUOM: editableData?.OuterDimensions?.Volume
      ? editableData?.OuterDimensions?.VolumeUOM
      : null,
    Ti: editableData?.OuterDimensions?.Ti || null,
    Hi: editableData?.OuterDimensions?.Hi || null,
    BreakPackQty: editableData?.OuterDimensions?.BreakPackQty || null,
  };
}